// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Qr1Q","newExpiryDate":"styles_newExpiryDate__2plUQ","footer":"styles_footer__Q7UkR"};